import app from 'flarum/forum/app';
import { invalidate } from './widgetData';

/** A serialized event (mirrors ErnestDefoe\Calendar\Api\EventSerializer). */

const api = path => app.forum.attribute('apiUrl') + path;
export const base = () => app.forum.attribute('baseUrl');
export function onThisDay(limit = 6) {
  return app.request({
    method: 'GET',
    url: api('/calendar/onthisday?limit=' + limit)
  }).then(r => r.data);
}
export function celebrations() {
  return app.request({
    method: 'GET',
    url: api('/calendar/celebrations')
  }).then(r => r.data);
}

/** Absolute URL for a server path the serializer handed us (e.g. an .ics path). */
export const abs = path => base().replace(/\/$/, '') + '/' + path.replace(/^\//, '');
export const feedUrl = () => abs('calendar/feed.ics');
export function userActivity(userId) {
  return app.request({
    method: 'GET',
    url: api('/calendar/activity/' + userId)
  }).then(r => r.data);
}
export function forumPulse(opts = {}) {
  const qs = new URLSearchParams();
  if (opts.days) qs.set('days', String(opts.days));
  if (opts.leaderDays) qs.set('leaderDays', String(opts.leaderDays));
  if (opts.limit) qs.set('limit', String(opts.limit));
  const s = qs.toString();
  return app.request({
    method: 'GET',
    url: api('/calendar/pulse' + (s ? '?' + s : ''))
  }).then(r => r.data);
}
export function listEvents(from, to, category) {
  const qs = new URLSearchParams({
    from: from.toISOString(),
    to: to.toISOString()
  });
  if (category) qs.set('category', category);
  return app.request({
    method: 'GET',
    url: api('/calendar/events?' + qs.toString())
  });
}
export function showEvent(id) {
  return app.request({
    method: 'GET',
    url: api('/calendar/events/' + id)
  }).then(r => r.data);
}
export function saveEvent(attrs, id) {
  return app.request({
    method: id ? 'PATCH' : 'POST',
    url: api('/calendar/events' + (id ? '/' + id : '')),
    body: {
      data: {
        attributes: attrs
      }
    }
  }).then(r => {
    invalidate('events:');
    return r.data;
  });
}

/** Start the comment thread for an event that has none. */
export function startDiscussion(id) {
  return app.request({
    method: 'POST',
    url: api('/calendar/events/' + id + '/discussion')
  }).then(r => {
    invalidate('events:');
    return r.data;
  });
}
export function deleteEvent(id) {
  return app.request({
    method: 'DELETE',
    url: api('/calendar/events/' + id)
  }).then(r => {
    invalidate('events:');
    return r;
  });
}
export function rsvp(id, status) {
  return app.request({
    method: 'POST',
    url: api('/calendar/events/' + id + '/rsvp'),
    body: {
      data: {
        status
      }
    }
  }).then(r => {
    invalidate('events:');
    return r.data;
  });
}
export function listCategories() {
  return app.request({
    method: 'GET',
    url: api('/calendar/categories')
  }).then(r => r.data);
}
export function saveCategory(attrs, id) {
  return app.request({
    method: id ? 'PATCH' : 'POST',
    url: api('/calendar/categories' + (id ? '/' + id : '')),
    body: {
      data: {
        attributes: attrs
      }
    }
  }).then(r => r.data);
}
export function deleteCategory(id) {
  return app.request({
    method: 'DELETE',
    url: api('/calendar/categories/' + id)
  });
}
flarum.reg.add('ernestdefoe-calendar', 'common/api', { base: base,onThisDay: onThisDay,celebrations: celebrations,abs: abs,feedUrl: feedUrl,userActivity: userActivity,forumPulse: forumPulse,listEvents: listEvents,showEvent: showEvent,saveEvent: saveEvent,startDiscussion: startDiscussion,deleteEvent: deleteEvent,rsvp: rsvp,listCategories: listCategories,saveCategory: saveCategory,deleteCategory: deleteCategory, });